import { Sidebar } from '@anytag/shared-atoms';
import { useInfluencerSearchPathnames, useMatchPaths } from '@anytag/shared-hooks';
import { AIAssistant } from '../ai-assistant';

export const AiAssistantSidebar = () => {
  const { supportedInfluencerSearchPaths } = useInfluencerSearchPathnames();
  const { matched } = useMatchPaths(supportedInfluencerSearchPaths);

  return matched ? (
    <Sidebar
      name="ai-assistant"
      variant="sidebar"
      side="right"
      collapsible="offcanvas"
      className="relative z-10 h-screen w-full rounded-l-lg"
    >
      <AIAssistant />
    </Sidebar>
  ) : null;
};
